import {view} from '@sail/ui';
import {HelmIcon} from '@sail/helm';
import type {HelmIconAsset} from '@sail/helm';
import {createViewConfig} from '@sail/engine';
import type {View} from '@sail/engine';
import {styles} from 'mkt-ssr/components/sail/ListItem/ListItemStyles';

export type ListItemProps = View.IntrinsicElement<
  'li',
  {
    /**
     * The text displayed as the label of this list item
     */
    label?: string;
    /**
     * Content to be displayed inside the ListItem
     */
    children?: React.ReactNode;
    /**
     * The icon displayed to the left of the list item
     */
    icon?: HelmIconAsset;
    subviews?: View.Subviews<{
      label: 'label';
      icon: 'svg';
    }>;
  }
>;

// eslint-disable-next-line @stripe-internal/stripe/no-mixed-react-exports
export const ListItemConfig = createViewConfig({
  props: {} as ListItemProps,
  name: 'ListItem',
});

/**
 * The individual list items used as children of the `<List />` component
 */
export const ListItem = ListItemConfig.createView(
  ({children, label, icon, inherits, subviews, ...rest}) => {
    return (
      <view.li
        {...rest}
        uses={[styles.container, styles.containerUnprocessedCss]}
      >
        {icon ? <HelmIcon icon={icon} uses={[styles.icon]} /> : null}
        {label ? (
          <view.span inherits={subviews.label}>{label}</view.span>
        ) : (
          <>{children}</>
        )}
      </view.li>
    );
  },
);
